export default {
  id: 'ReactTimeLine',
  code: 'CN',
  text: {
    'Complete': '确认完成',
    'Completed': '已完成',
    'Edit': '编辑',
    'Delete': '删除',
    'Person In Charge: {name}': '负责老师：{name}',
    'Reminder Time: {time}': '提醒时间：{time}',
    'Proceed to delete task?': '确认删除事项',
    '': '',
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/ReactTimeline/locale.js